import { render, staticRenderFns } from "./SantamSharedServicesAward.vue?vue&type=template&id=4c1b5912&"
import script from "./SantamSharedServicesAward.vue?vue&type=script&lang=js&"
export * from "./SantamSharedServicesAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports